/*! Wi-reviews - v0.0.1
 * https://www.wicode.pl/
 * Copyright (c) 2017 Wicode; */

;(function ($) {
    'use strict';

    function initPeekCarousel($carousel) {
        var $items = $carousel.find('.carousel-inner .item');
        var total  = $items.length;
        if (total < 2) return;

        var current     = 0;
        var isAnimating = false;
        var interval    = parseInt($carousel.data('interval'), 10) || 0;
        var autoTimer;

        $carousel.css('overflow', 'hidden');
        $carousel.find('.carousel-inner').css('overflow', 'visible');
        $items.css({
            display:    'block',
            position:   'absolute',
            width:      '60%',
            left:       '20%',
            transition: 'transform 0.45s ease, opacity 0.45s ease'
        });

        function fixHeight() {
            var maxH = 0;
            $items.each(function () { maxH = Math.max(maxH, $(this).outerHeight(true)); });
            if (maxH > 0) {
                $carousel.find('.carousel-inner').css('height', maxH + 20);
            }
        }
        $(window).on('resize', fixHeight);

        function goTo(idx) {
            if (isAnimating) return;
            isAnimating = true;
            current = ((idx % total) + total) % total;

            $items.each(function (i) {
                var off = i - current;
                if (off >  total / 2) off -= total;
                if (off < -total / 2) off += total;

                var tx      = off * 108;
                var opacity = off === 0 ? 1 : Math.abs(off) === 1 ? 0.5 : 0;
                var scale   = off === 0 ? 1 : 0.88;
                var zIndex  = off === 0 ? 3 : Math.abs(off) === 1 ? 2 : 0;

                $(this)
                    .css({
                        transform:  'translateX(' + tx + '%) scale(' + scale + ')',
                        opacity:    opacity,
                        'z-index':  zIndex,
                        visibility: Math.abs(off) > 1 ? 'hidden' : 'visible'
                    })
                    .toggleClass('active', off === 0);
            });

            $carousel.find('.carousel-indicators li')
                .removeClass('active')
                .eq(current).addClass('active');

            setTimeout(function () { isAnimating = false; }, 500);
        }

        function resetTimer() {
            clearInterval(autoTimer);
            if (interval > 0) {
                autoTimer = setInterval(function () { goTo(current + 1); }, interval);
            }
        }

        // Rebind controls (override BS3)
        $carousel.find('.carousel-control.right, [data-slide="next"]')
            .off('click').on('click', function (e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                resetTimer();
                goTo(current + 1);
            });

        $carousel.find('.carousel-control.left, [data-slide="prev"]')
            .off('click').on('click', function (e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                resetTimer();
                goTo(current - 1);
            });

        $carousel.find('.carousel-indicators li')
            .off('click').on('click', function (e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                resetTimer();
                goTo($(this).data('slide-to'));
            });

        // Touch swipe (swipe.js already in bundle)
        if ($carousel.find('.carousel-inner').swipe) {
            $carousel.find('.carousel-inner').swipe({
                swipeLeft:  function () { resetTimer(); goTo(current + 1); },
                swipeRight: function () { resetTimer(); goTo(current - 1); },
                threshold:  0
            });
        }

        // Read-more toggle — only when content is actually clamped
        $items.find('.review-content').each(function () {
            var $content = $(this);
            var $btn = $('<button class="review-read-more">czytaj więcej</button>').hide();
            $btn.on('click', function (e) {
                e.stopPropagation();
                var expanded = $content.toggleClass('expanded').hasClass('expanded');
                $btn.text(expanded ? 'zwiń' : 'czytaj więcej');
                fixHeight();
            });
            $content.after($btn);
        });

        // Disable BS3 auto-advance; manage it ourselves
        $carousel.carousel({ interval: false });
        goTo(0);
        fixHeight();

        // Show read-more only where text overflows (after layout is done)
        $items.find('.review-content').each(function () {
            if (this.scrollHeight > this.clientHeight + 2) {
                $(this).next('.review-read-more').show();
            }
        });

        if (interval > 0) {
            resetTimer();
            if ($carousel.data('pause') === 'hover') {
                $carousel.hover(
                    function () { clearInterval(autoTimer); },
                    function () { resetTimer(); }
                );
            }
        }
    }

    $(function () {
        // Matches .reviews-2up, .reviews-3up, .reviews-4up, .reviews-6up
        $('.reviews-carousel .carousel').filter(function () {
            return /reviews-\dup/.test(this.className);
        }).each(function () {
            initPeekCarousel($(this));
        });
    });

}(jQuery));
